// extracted by mini-css-extract-plugin
module.exports = {"container":"_268sWGsfizainPdmfabOOq","tabs":"_1fhjtgfGcuTXrckOnkjufR","tabsTitle":"_1iTPMC_53mJduI9-YmPBTD","content":"HPzLVDSlPHZ3q0B-he3Qd"};